import { useEffect, useState, useRef, useContext } from 'react';
import api from 'api';
import { get } from 'utils/fetch';
import { message, Spin, Input, Switch, Select, Space } from 'antd';
import { InvestorInsertion } from 'pages/RecordInsertion/InvestorInsertion';
import { GlobalContext } from 'GlobalContext';
import { InvestorTableView } from 'pages/Tables/InvestorTableView';
import { isAdmin, isPhoneSize, shadeColor } from 'utils/util';
import * as XLSX from 'xlsx';
import {
    USDollar,
    formatCurrency,
    USD_TO_CNY,
    sumAllFormatUSD,
    sumUSDFormat,
    sumCNYFormat,
} from 'utils/format';

export function InvestorManager(props) {
    function InvestorTable() {
        function Header() {
            function HeaderItem(props) {
                const { text, width } = props;
                return (
                    <div
                        style={{
                            width: `${width}px`,
                        }}
                    >
                        {text}
                    </div>
                );
            }
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '1270px',
                        background: panelBackgroundColor,
                        borderRadius: '4px 4px 0 0',
                    }}
                >
                    <div
                        style={{
                            width: '200px',
                            margin: '0px 20px',
                            marginRight: '0px',
                        }}
                    >
                        Investors
                    </div>
                    <HeaderItem text={'DRIs'} width={150} />
                    <HeaderItem text={'Referral'} width={150} />
                    <HeaderItem text={'Investment Entities'} width={150} />
                    <HeaderItem text={'Commitment Number'} width={150} />
                    <HeaderItem text={'Equity Balance'} width={150} />
                    <HeaderItem text={'Distribute Interest'} width={150} />
                    <HeaderItem text={'Principal Return'} width={150} />
                </div>
            );
        }

        function PerInvestor(props) {
            function PerAccount(props) {
                const { idx, account, background } = props;
                const positionsByCurAccount = allPositionsListView.filter(
                    (position) => position.account_id === account.account_id
                );
                const usdPositions = positionsByCurAccount.filter(
                    (position) => position.currency.toLowerCase() === 'usd'
                );

                const cnyPositions = positionsByCurAccount.filter(
                    (position) => position.currency.toLowerCase() === 'cny'
                );

                function DisplayPositionCurrencySum({ sumMethod, positions }) {
                    if (positions.length === 0) return <></>;
                    return (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            {[
                                'amount',
                                'account_balance',
                                'interest_received',
                                'principal_returned',
                            ].map((type, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        width: '150px',
                                    }}
                                >
                                    {sumMethod(positions, type)}
                                </div>
                            ))}
                        </div>
                    );
                }

                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            // borderBottom: '1px solid black',
                            background,
                        }}
                    >
                        <div
                            style={{
                                width: '150px',
                                color: 'blue',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                alignContent: 'center',
                            }}
                            onClick={() => {
                                setManageRecordId(account.account_id);
                                setManageRecordTab('Investment Entities');
                            }}
                        >
                            {account.account_name}
                        </div>

                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <DisplayPositionCurrencySum
                                sumMethod={sumUSDFormat}
                                positions={usdPositions}
                            />
                            <DisplayPositionCurrencySum
                                sumMethod={sumCNYFormat}
                                positions={cnyPositions}
                            />
                        </div>
                    </div>
                );
            }
            const { idx, investor, background } = props;
            const accountIds = new Set(
                investorIdToAccount
                    .filter((account) => account.investor_id === investor.id)
                    .map((account) => account.account_id)
            );
            const positionsOfCurInvestor = allPositionsListView.filter(
                (position) => accountIds.has(position.account_id)
            );
            const usdPositions = positionsOfCurInvestor.filter(
                (position) => position.currency.toLowerCase() === 'usd'
            );

            const cnyPositions = positionsOfCurInvestor.filter(
                (position) => position.currency.toLowerCase() === 'cny'
            );

            const investorIdToAccountCurInvestor = investorIdToAccount.filter(
                (account) => account.investor_id === investor.id
            );

            function DisplayPositionCurrencySumByInvestor({
                sumMethod,
                positions,
                currency,
            }) {
                if (positions.length === 0) return <></>;
                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            fontWeight: 'bold',
                        }}
                    >
                        <div
                            style={{
                                width: '150px',
                            }}
                        >
                            {`Sum ${currency.toUpperCase()}`}
                        </div>
                        {[
                            'amount',
                            'account_balance',
                            'interest_received',
                            'principal_returned',
                        ].map((type, idx) => (
                            <div
                                key={idx}
                                style={{
                                    width: '150px',
                                }}
                            >
                                {sumMethod(positions, type)}
                            </div>
                        ))}
                    </div>
                );
            }
            return (
                <div
                    key={idx}
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        width: '1270px',
                        // borderTop: '1px solid black',
                        background,
                    }}
                >
                    <div
                        key={idx}
                        style={{
                            // fontSize: "20px",
                            margin: '5px 20px',
                            marginRight: '0px',
                            width: '200px',
                            color: 'blue',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        onClick={() => setManageRecordId(investor.id)}
                    >
                        {`${investor.legal_name} (${investor.email})`}
                    </div>

                    <div style={{ width: '150px' }}>
                        {DRIs.filter((dri) => dri.id == investor.sale_id).map(
                            (dri, idx) => (
                                <div
                                    key={idx}
                                    style={{
                                        color: 'blue',
                                        textDecoration: 'underline',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => setManageRecordId(dri.id)}
                                >
                                    {dri.legal_name}
                                </div>
                            )
                        )}
                    </div>

                    <div
                        style={{
                            width: '150px',
                            color: 'blue',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                        onClick={() => setManageRecordId(investor.referral_id)}
                    >
                        {investor.referral_id &&
                            investors.find(
                                (referral) =>
                                    referral.id == investor.referral_id
                            ).legal_name}
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {investorIdToAccountCurInvestor.map((account, idx) => (
                            <PerAccount
                                account={account}
                                idx={idx}
                                key={idx}
                                background={
                                    idx % 2 === 0
                                        ? background
                                        : shadeColor(background, -3)
                                }
                            />
                        ))}

                        {/*  */}
                        <div
                            style={{
                                background:
                                    investorIdToAccountCurInvestor.length % 2
                                        ? shadeColor(background, -3)
                                        : background,
                            }}
                        >
                            <DisplayPositionCurrencySumByInvestor
                                sumMethod={sumUSDFormat}
                                positions={usdPositions}
                                currency={'USD'}
                            />

                            {/*  */}

                            <DisplayPositionCurrencySumByInvestor
                                sumMethod={sumCNYFormat}
                                positions={cnyPositions}
                                currency={'CNY'}
                            />
                        </div>
                        {/*  */}
                    </div>
                </div>
            );
        }

        function Body() {
            return (
                <>
                    {investors
                        .filter((investor) => {
                            if (driIdSelected === -1) {
                                return true;
                            } else {
                                return (
                                    investor.sale_id === driIdSelected ||
                                    investor.id === driIdSelected
                                );
                            }
                        })
                        .filter(
                            (investor) =>
                                investor.legal_name
                                    .toLowerCase()
                                    .includes(
                                        filteredText.trim().toLowerCase()
                                    ) ||
                                investor.email
                                    .toLowerCase()
                                    .includes(
                                        filteredText.trim().toLowerCase()
                                    ) ||
                                `${investor.preferred_first_name} ${investor.last_name}`
                                    .toLowerCase()
                                    .includes(filteredText.trim().toLowerCase())
                        )
                        .sort((a, b) => {
                            const balanceA = allPositionsListView
                                .filter((position) => {
                                    const accountIds = new Set(
                                        investorIdToAccount
                                            .filter(
                                                (account) =>
                                                    account.investor_id === a.id
                                            )
                                            .map(
                                                (account) => account.account_id
                                            )
                                    );
                                    return accountIds.has(position.account_id);
                                })
                                .reduce((acc, cur) => {
                                    const amount =
                                        cur.currency.toLowerCase() === 'cny'
                                            ? cur.account_balance / USD_TO_CNY
                                            : cur.account_balance;
                                    return acc + amount;
                                }, 0);

                            const balanceB = allPositionsListView
                                .filter((position) => {
                                    const accountIds = new Set(
                                        investorIdToAccount
                                            .filter(
                                                (account) =>
                                                    account.investor_id === b.id
                                            )
                                            .map(
                                                (account) => account.account_id
                                            )
                                    );
                                    return accountIds.has(position.account_id);
                                })
                                .reduce((acc, cur) => {
                                    const amount =
                                        cur.currency.toLowerCase() === 'cny'
                                            ? cur.account_balance / USD_TO_CNY
                                            : cur.account_balance;
                                    return acc + amount;
                                }, 0);
                            if (balanceA === balanceB) {
                                if (a.id < b.id) {
                                    return -1;
                                }
                                return 1;
                            }
                            if (balanceA < balanceB) {
                                return 1;
                            }
                            return -1;
                        })
                        .map((investor, idx) => {
                            return (
                                <PerInvestor
                                    idx={idx}
                                    investor={investor}
                                    key={idx}
                                    background={backgroundColors[idx % 2]}
                                />
                            );
                        })}
                </>
            );
        }

        return (
            <div
                style={
                    isPhoneSize()
                        ? { height: 'calc(100vh - 440px)' }
                        : { height: 'calc(100vh - 223px)' }
                }
            >
                <div
                    style={
                        isPhoneSize()
                            ? {
                                  width: '100%',
                                  overflowX: 'auto',
                                  overflowY: 'scroll',
                                  height: '100%',
                              }
                            : {
                                  width: '',
                                  overflowY: 'scroll',
                                  height: '100%',
                              }
                    }
                >
                    <Header />
                    <Body />
                </div>
            </div>
        );
    }
    const [messageApi, contextHolder] = message.useMessage();
    const {
        setManageRecordId,
        manageRecordId,
        accessToken,
        globalId,
        refreshSession,
        setManageRecordTab,
    } = useContext(GlobalContext);
    const { filteredText, setFilteredText } = props;
    // const [filteredText, setFilteredText] = useState('');
    const fileInputRef = useRef(null); // Reference to the file input element
    const [loading, setLoading] = useState(true);
    const [investors, setInvestors] = useState([]);
    const [investorId, setInvestorId] = useState(0); // 0: main page
    // const [accounts, setAccounts] = useState([])
    const [file, setFile] = useState(null);
    const [fileContent, setFileContent] = useState(null);
    const [fileSubmitButtonText, setFileSubmitButtonText] = useState('Submit');
    const [fileSubmitButtonWidth, setFileSubmitButtonWidth] = useState('70px');
    // list view or table view for display
    const [currentView, setCurrentView] = useState('List View');
    const [allPositions, setAllPositions] = useState([]);
    const [accountIdToInvestorsAll, setAccountIdToInvestorsAll] = useState({});
    const [DRIs, setDRIs] = useState([]);
    const [driIdSelected, setDriIdSelected] = useState(-1);
    const [allPositionsListView, setAllPositionsListView] = useState(null);
    const [investorIdToAccount, setInvestorIdToAccount] = useState([]);
    const defaultFilterByDRIText = 'All Investors';

    const backgroundColors = ['#f5f5f5', '#e9f0f8'];
    const panelBackgroundColor = '#e0e0e0';

    var driName2id = { 'All Investors': -1 };
    for (const dri of DRIs) {
        driName2id[dri.legal_name] = dri.id;
    }

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];

        // Check if the selected file is a CSV file
        if (selectedFile && selectedFile.type === 'text/csv') {
            setFile(selectedFile);
            readFile(selectedFile);
        } else {
            alert('Please select a valid CSV file.');
            e.target.value = null; // Reset the input if it's not a CSV file
        }
    };

    const readFile = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const content = e.target.result;
            validateCSV(content);
        };
        reader.readAsText(file);
    };

    const validateCSV = (content) => {
        const rows = content.split('\n');

        // Example validation: Check that there are at least two rows (header + 1 data row)
        if (rows.length < 2) {
            fileInputRef.current.value = '';
            alert('CSV file must contain at least one row of data.');
            setFile(null);
            return;
        }

        // Example: Validate CSV headers (assuming the first row contains headers)
        const headers = rows[0].split(/[,\t\r]+/);
        // console.log(headers)
        const expectedHeaders = [
            'first name',
            'last name',
            'email',
            'phone',
            'date',
            'event',
        ]; // Replace with actual expected headers
        const missingHeaders = expectedHeaders.filter(
            (header) => !headers.includes(header)
        );
        const isHeaderValid = headers.every(
            (header, index) => header.trim() === expectedHeaders[index]
        );
        // console.log(missingHeaders)

        if (missingHeaders.length > 0) {
            fileInputRef.current.value = '';
            alert(`Missing columns: ${missingHeaders.join(', ')}`);
            setFile(null);
            return;
        }

        // Optionally, set file content if validation passes
        setFileContent(content);
    };
    // console.log("globalId", globalId)
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (fileSubmitButtonText === 'Submitting') {
            return;
        }
        setSubmittingStatus();

        if (!file || !fileContent) {
            alert('Please select a valid file!');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(api.file.investorBulkUpload, {
                method: 'POST',
                body: formData,
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.ok) {
                console.log('File uploaded successfully');
            } else {
                console.error('File upload failed');
            }
        } catch (error) {
            console.error('Error during file upload:', error);
        }
        refreshSession();
        unsetSubmittingStatus();
    };

    function setSubmittingStatus() {
        setFileSubmitButtonText('Submitting');
        setFileSubmitButtonWidth('100px');
    }

    function unsetSubmittingStatus() {
        fetchInvestors();
        setFileSubmitButtonText('Submit');
        setFileSubmitButtonWidth('70px');
        setFile(null);
        fileInputRef.current.value = '';
    }

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchAllPositions() {
        await get(
            api.manager.allInvestorPositions,
            setAllPositions,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        if (isAdmin()) {
            setLoading(false);
        }
    }

    async function fetchAllPositionsListView() {
        await get(
            api.manager.allInvestorPositionsListView,
            setAllPositionsListView,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAllInvestorIdToAccount() {
        await get(
            api.manager.investorIdToAccount,
            setInvestorIdToAccount,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchAccountIdToInvestorsAll() {
        await get(
            api.manager.accountIdToInvestorsAll + `?sale_id=${globalId}`,
            setAccountIdToInvestorsAll,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    async function fetchInvestors() {
        await get(
            api.manager.investors + `?sale_id=${globalId}`,
            setInvestors,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }

    async function fetchDRIs() {
        await get(
            api.manager.DRIs,
            setDRIs,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
    }
    // console.log(DRIs)
    const driSelectionOptions = [
        {
            label: defaultFilterByDRIText,
            value: -1,
            desc: defaultFilterByDRIText,
        },
        ...DRIs.sort((a, b) => {
            if (a.legal_name.toLowerCase() < b.legal_name.toLowerCase()) {
                return -1;
            }
            return 1;
        }).map((DRI) => {
            return {
                label: DRI.legal_name,
                value: DRI.id,
                desc: DRI.legal_name,
            };
        }),
    ];

    // console.log(investors)
    useEffect(() => {
        if (
            accessToken === null ||
            accessToken === undefined ||
            accessToken === '' ||
            globalId === 0
        )
            return;
        if (manageRecordId !== 0) {
            setLoading(false);
        }
        // setFilteredText('');
        if (manageRecordId !== 0) return;
        if (isAdmin()) {
            fetchDRIs();
        }
        fetchAccountIdToInvestorsAll();
        fetchInvestors();
        fetchAllPositions();
        fetchAllPositionsListView();
        fetchAllInvestorIdToAccount();
        // fetchAccounts()
    }, [manageRecordId, accessToken, globalId]);

    const downloadCSV = () => {
        fetch(api.manager.downloadInvestors, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.blob(); // Convert response to blob
                }
                throw new Error('Error while downloading CSV');
            })
            .then((blob) => {
                // Create a link element to trigger download
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'investors.csv'); // Specify file name
                refreshSession();
                document.body.appendChild(link);
                link.click(); // Simulate click to download
                link.remove(); // Remove link from DOM after downloading
            })
            .catch((error) => {
                console.error('Error downloading the CSV file:', error);
            });
    };

    function handleCurrentViewChange(view) {
        if (view) {
            setCurrentView('Table View');
        } else {
            setCurrentView('List View');
        }
    }

    const handleMyDRIChange = (driId) => {
        setDriIdSelected(driId);
    };

    // export investor table view into excel
    function exportToExcel(data, fileName = 'Investor_Report.xlsx') {
        try {
            // Create a new workbook
            const workbook = XLSX.utils.book_new();

            // Convert data to worksheet with minimal formatting
            const worksheet = XLSX.utils.aoa_to_sheet(data, {
                cellDates: true, // Handle dates properly
                raw: false, // Use more basic cell formatting
            });

            // Set very basic column widths
            worksheet['!cols'] = Array(data[0].length).fill({ wch: 20 });

            // Set basic row heights
            worksheet['!rows'] = Array(data.length).fill({});

            // Append worksheet with minimal styling
            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                'Investor Summary'
            );

            // Write file with basic options
            const wopts = {
                bookType: 'xlsx',
                type: 'binary',
                cellStyles: false, // Disable complex styling
                cellDates: true,
                bookSST: false, // Disable shared strings table
            };

            XLSX.writeFile(workbook, fileName, wopts);
        } catch (error) {
            console.error('Error generating Excel file:', error);
        }
    }
    function generateInvestoTableView() {
        var data = [
            [
                'Investors',
                'Investment Entities',
                'Funds',
                'Commitment Number',
                'Equity Balance',
                'Distribute Interest',
                'Principal Return',
                'Interest Rate',
                'Capital In Date',
                'End Date',
            ], // Headers
        ];
        for (const account_id of Object.keys(accountIdToInvestorsAll)) {
            const investors = accountIdToInvestorsAll[account_id];
            const investorText = investors
                .map((investor) => {
                    if (!investor.legal_name && !investor.email) {
                        return '';
                    } else if (!investor.legal_name) {
                        return investor.email;
                    } else if (!investor.email) {
                        return investor.legal_name;
                    } else {
                        return `${investor.legal_name}\n${investor.email}`;
                    }
                })
                .join('\n');
            const positions = allPositions.filter(
                (position) => position.account_id === parseInt(account_id)
            );
            for (const position of positions) {
                var curPositionRow = [];
                curPositionRow.push(investorText);
                curPositionRow.push(investors[0].account_name);
                curPositionRow.push(position.name);
                curPositionRow.push(
                    formatCurrency(position.amount, position.currency)
                );
                curPositionRow.push(
                    formatCurrency(position.account_balance, position.currency)
                );
                curPositionRow.push(
                    formatCurrency(
                        position.interest_received,
                        position.currency
                    )
                );
                curPositionRow.push(
                    formatCurrency(
                        position.principal_returned,
                        position.currency
                    )
                );
                curPositionRow.push(
                    `${
                        position.overall_interest
                            ? Math.max(
                                  position.overall_interest,
                                  position.annual_interest_rate
                              )
                            : position.annual_interest_rate
                    }%`
                );
                curPositionRow.push(position.funding_receipt_date.slice(0, 10));
                curPositionRow.push(
                    position.actual_redemption_date.slice(0, 10)
                );
                data.push(curPositionRow);
            }
        }
        return data;
    }
    function getLoadingStatus() {
        if (manageRecordId !== 0) return 'detail';
        if (loading || !allPositionsListView) return 'loading';
        return 'ready';
    }
    const [loadingStatus, setLoadingStatus] = useState(getLoadingStatus());

    useEffect(() => {
        setLoadingStatus(getLoadingStatus());
    }, [manageRecordId, loading, allPositionsListView]);

    return (
        <>
            {loadingStatus === 'loading' && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {loadingStatus === 'ready' && (
                <>
                    <div
                        style={
                            isPhoneSize()
                                ? {
                                      display: 'flex',
                                      flexDirection: 'column',
                                  }
                                : {
                                      display: 'flex',
                                      flexDirection: 'row',
                                  }
                        }
                    >
                        <div
                            style={{
                                width: '150px',
                                marginTop: '30px',
                                marginLeft: '20px',
                                display: 'flex',
                                flexDirection: 'row',
                            }}
                        >
                            <Input
                                onChange={(e) =>
                                    setFilteredText(e.target.value)
                                }
                                value={filteredText}
                                placeholder="Filter on name or email"
                            />
                            {filteredText && (
                                <div
                                    onClick={() => setFilteredText('')}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#888',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                        userSelect: 'none',
                                    }}
                                >
                                    ×
                                </div>
                            )}
                        </div>
                        <div
                            style={
                                isPhoneSize()
                                    ? {
                                          marginTop: '10px',
                                          marginLeft: '20px',
                                      }
                                    : {
                                          marginTop: '30px',
                                          marginLeft: '20px',
                                      }
                            }
                        >
                            {isAdmin() && currentView === 'List View' && (
                                <div
                                    style={
                                        isPhoneSize()
                                            ? {
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                              }
                                            : {
                                                  display: 'flex',
                                                  flexDirection: 'row',
                                                  alignItems: 'center',
                                              }
                                    }
                                >
                                    <div>Filter by DRI: </div>
                                    <span style={{ width: '150px' }}>
                                        <Select
                                            showSearch
                                            style={
                                                isPhoneSize()
                                                    ? {
                                                          width: '150px',
                                                      }
                                                    : {
                                                          width: '150px',
                                                          marginLeft: '5px',
                                                      }
                                            }
                                            placeholder="select DRI"
                                            defaultValue={
                                                driName2id[driIdSelected]
                                            }
                                            onChange={handleMyDRIChange}
                                            options={driSelectionOptions}
                                            filterOption={(input, option) => {
                                                const { label, desc, value } =
                                                    option;
                                                const lowerInput = input
                                                    .trim()
                                                    .toLowerCase();
                                                return (
                                                    label
                                                        ?.toString()
                                                        .toLowerCase()
                                                        .includes(lowerInput) ||
                                                    desc
                                                        ?.toString()
                                                        .toLowerCase()
                                                        .includes(lowerInput) ||
                                                    value
                                                        ?.toString()
                                                        .toLowerCase()
                                                        .includes(lowerInput)
                                                );
                                            }}
                                            optionRender={(option) => (
                                                <Space>
                                                    <span
                                                        role="img"
                                                        aria-label={
                                                            option.data.label
                                                        }
                                                    >
                                                        {option.data.emoji}
                                                    </span>
                                                    {option.data.desc}
                                                </Space>
                                            )}
                                        />
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div
                        style={{
                            margin: '20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        {isAdmin() && (
                            <button
                                style={{
                                    height: '30px',
                                    width: '50px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setManageRecordId(-1)}
                            >
                                Add
                            </button>
                        )}

                        {isAdmin() && (
                            <form onSubmit={handleSubmit}>
                                {/* <label> */}
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept=".csv"
                                    onChange={handleFileChange}
                                    style={{ width: '200px' }}
                                />
                                {/* </label> */}
                                <button
                                    type="submit"
                                    style={{
                                        height: '30px',
                                        width: fileSubmitButtonWidth,
                                        borderRadius: '30px',
                                        background: 'rgb(17 32 86)',
                                        color: 'white',
                                        cursor: 'pointer',
                                    }}
                                >
                                    {fileSubmitButtonText}
                                </button>
                            </form>
                        )}

                        {currentView.toLowerCase() === 'list view' && (
                            <button
                                style={{
                                    height: '30px',
                                    width: '130px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={downloadCSV}
                            >
                                Export Investors
                            </button>
                        )}

                        {currentView.toLowerCase() === 'table view' && (
                            <button
                                style={{
                                    height: '30px',
                                    width: '160px',
                                    borderRadius: '30px',
                                    background: 'rgb(17 32 86)',
                                    color: 'white',
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    exportToExcel(generateInvestoTableView())
                                }
                            >
                                Export Investor Table
                            </button>
                        )}
                    </div>

                    <div style={{ margin: '20px' }}>
                        <Switch
                            // className="investment-status-switch"
                            checkedChildren="Table View"
                            unCheckedChildren="List View"
                            onChange={handleCurrentViewChange}
                            checked={currentView.toLowerCase() === 'table view'}
                        />
                    </div>

                    {currentView.toLowerCase() === 'list view' && (
                        <div>{`Investor/User Count: ${
                            investors
                                .filter((investor) => {
                                    if (driIdSelected === -1) {
                                        return true;
                                    } else {
                                        return (
                                            investor.sale_id ===
                                                driIdSelected ||
                                            investor.id === driIdSelected
                                        );
                                    }
                                })
                                .filter(
                                    (investor) =>
                                        investor.legal_name
                                            .toLowerCase()
                                            .includes(
                                                filteredText
                                                    .trim()
                                                    .toLowerCase()
                                            ) ||
                                        investor.email
                                            .toLowerCase()
                                            .includes(
                                                filteredText
                                                    .trim()
                                                    .toLowerCase()
                                            ) ||
                                        `${investor.preferred_first_name} ${investor.last_name}`
                                            .toLowerCase()
                                            .includes(
                                                filteredText
                                                    .trim()
                                                    .toLowerCase()
                                            )
                                ).length
                        }`}</div>
                    )}

                    {currentView.toLowerCase() === 'list view' && (
                        <InvestorTable />
                    )}

                    {currentView.toLowerCase() === 'table view' && (
                        <div
                            style={
                                isPhoneSize()
                                    ? { height: 'calc(100vh - 404px)' }
                                    : { height: 'calc(100vh - 218px)' }
                            }
                        >
                            <div
                                style={{ height: '100%', overflowY: 'scroll' }}
                            >
                                <InvestorTableView
                                    filteredText={filteredText}
                                    allPositions={allPositions}
                                    accountIdToInvestorsAll={
                                        accountIdToInvestorsAll
                                    }
                                    backgroundColors={backgroundColors}
                                    panelBackgroundColor={panelBackgroundColor}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
            {loadingStatus === 'detail' && manageRecordId > 0 && (
                <>
                    <InvestorInsertion
                    // investor={investors.filter(investor => investor.id === investorId)[0]}
                    // setInvestorId={setInvestorId}
                    // accounts={accounts}
                    />
                </>
            )}
            {loadingStatus === 'detail' && manageRecordId < 0 && (
                <>
                    <InvestorInsertion
                    // investor={null}
                    // setInvestorId={setInvestorId}
                    // accounts={accounts}
                    />
                </>
            )}
        </>
    );
}
